<template>
    <div id="book">
        <headers :title='titles'></headers>
        <div v-if="loading">
            <h3 v-if="DataList.word.length || DataList.book.length"
                class="weight">{{name}}</h3>
            <div v-if="DataList.word.length || DataList.book.length">
                <h3 v-if="DataList.word.length">单词跟读</h3>
                <ul class="list">
                    <li class="clearfix"
                        v-for="(data,index) in DataList.word">
                        <div class="left_title"
                             v-if="data.type==4">
                            <span class="name">单词（{{data.word_num}}个）</span>
                        </div>
                        <div class="right_btn">
                            <span class="YL_btn"
                                  @click="toPreview(data,0)">预览</span>
                            <div class="add_btn"
                                 v-if="!data.choose"
                                 @click="add(data,index)">加入</div>
                            <div class="dele_btn"
                                 v-else
                                 @click="dele(data,index)">移除</div>
                        </div>
                    </li>
                </ul>
                <h3 v-if="DataList.book.length">课文跟读</h3>
                <ul class="list">
                    <li class="clearfix"
                        v-for="(data,index) in DataList.book">
                        <div class="left_title"
                             v-if="data.type==1 || data.type==3">
                            <span class="name">{{data.name}}</span>
                        </div>
                        <div class="right_btn">
                            <span class="YL_btn"
                                  @click="toPreview(data,1)">预览</span>
                            <div class="add_btn"
                                 v-if="!data.choose"
                                 @click="add(data,index)">加入</div>
                            <div class="dele_btn"
                                 v-else
                                 @click="dele(data,index)">移除</div>
                        </div>
                    </li>
                </ul>
                <div v-if='test_num==0'
                     :class="['bottom_btn',{'able':test_num>0,'disable':test_num==0}]">已选{{test_num}}项，点击预览</div>
                <div v-else
                     @click="toPreview(0,2)"
                     :class="['bottom_btn',{'able':test_num>0,'disable':test_num==0}]">已选{{test_num}}项，点击预览</div>
            </div>
            <div v-else>
                <noResouse></noResouse>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';
export default {
    data () {
        return {
            titles: '课文预习',
            test_num: 0,//已选试题数量
            DataList: {
                word: [],
                book: [],
            },
            chooseData: {
                word: [],
                book: [],
            },//选中的信息
            loading: false,
            catalogId: this.$route.params.id,
            name: '',
        }
    },
    created () {
        let _sendok = localStorage.getItem('sendok');
        // //console.log(_sendok)
        if (_sendok == 1) {
            this.$router.go(-1);//发布过返回选内容
        } else {
            this.name = this.$store.state.english.title;
            this.$http.post(API_URL_TASK_API + '/english/send/catalog/preview', { catalog_id: this.catalogId, sid: 91 }).then(res => {
                if (res.data.response === 'ok') {
                    res = res.data;
                    this.loading = true;
                    // let _list={word:[],book:[]}
                    res.data.forEach(data => {
                        if (data.type == 4) {
                            this.DataList.word.push(data);
                        } else if (data.type == 1 || data.type == 3) {
                            this.DataList.book.push(data)
                        }
                    });
                    // this.DataList = _list;
                    //console.log(this.DataList.length)
                }
            })
        }
    },
    components: {
        headers,
        loadingS,
        noResouse
    },
    methods: {
        toPreview (data, type) {
            if (data) {
                this.$router.push('/english/before/preview/' + type + '?id=' + data.id);
            } else {
                if (this.test_num > 0) {
                    this.$store.commit('setBeforeData', this.chooseData);
                    this.$router.push('/english/before/preview/' + type);
                }
            }
        },
        add (data, index) {
            if (data.type == 4) {
                this.test_num = this.test_num + data.word_num;
                this.DataList.word[index].choose = true;
                this.DataList.word.splice(index, 1, this.DataList.word[index]);
                this.chooseData.word.push(data.id);
            } else {
                this.test_num++;
                this.DataList.book[index].choose = true;
                this.DataList.book.splice(index, 1, this.DataList.book[index]);
                this.chooseData.book.push(data.id);
            }
        },
        dele (data, index) {
            if (data.type == 4) {
                this.test_num = this.test_num - data.word_num;
                this.DataList.word[index].choose = false;
                this.DataList.word.splice(index, 1, this.DataList.word[index]);
                this.chooseData.word = [];
            } else {
                this.test_num--;
                this.DataList.book[index].choose = false;
                this.DataList.book.splice(index, 1, this.DataList.book[index]);
                let _index = this.chooseData.book.findIndex(item => data.id == item);
                this.chooseData.book.splice(_index, 1);
            }
            // //console.log(this.chooseData)
        }
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";
#book {
    font-size: 30px / $ppr;
    padding-bottom: 100px / $ppr;
}
h3 {
    font-size: 30px / $ppr;
    line-height: 96px / $ppr;
    height: 96px / $ppr;
    // border-top:1px/$ppr solid #dcdcdc;
    border-top: 1px / $ppr solid #e8e8e8;
    padding: 0 25px / $ppr;
    background: #fff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #333;
}
.weight {
    font-weight: bold;
}
.list {
    width: 100%;
    // padding-bottom:100px/$ppr;
    li {
        padding: 24px / $ppr 0;
        width: 100%;
        line-height: 48px / $ppr;
        border-top: 1px / $ppr solid #e8e8e8;
        background: #fff;
        .left_title {
            float: left;
            padding-left: 24px / $ppr;
            .name {
                width: 400px / $ppr;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                line-height: 46px / $ppr;
                color: #555;
            }
            .pass {
                display: inline-block;
                color: #999;
            }
        }
        .right_btn {
            float: right;
            width: 235px / $ppr;
            .YL_btn {
                display: inline-block;
                width: 80px / $ppr;
                color: $c-theme;
            }
        }
        .add_btn {
            display: inline-block;
            border: 1px / $ppr solid $c-theme;
            border-radius: 24px / $ppr;
            color: $c-theme;
            line-height: 48px / $ppr;
            height: 48px / $ppr;
            width: 122px / $ppr;
            text-align: center;
            font-size: 24px / $ppr;
            box-sizing: border-box;
        }
        .dele_btn {
            display: inline-block;
            border: 1px / $ppr solid #ff6600;
            border-radius: 24px / $ppr;
            color: #ff6600;
            line-height: 48px / $ppr;
            height: 48px / $ppr;
            width: 122px / $ppr;
            text-align: center;
            font-size: 24px / $ppr;
            box-sizing: border-box;
            // margin:10px/$ppr 25px/$ppr 0 0;
        }
        // &:last-child{
        //     border-bottom:none;
        // }
    }
}
.bottom_btn {
    width: 100%;
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    font-size: 32px / $ppr;
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
}
.disable {
    background: #ccc;
    color: #999;
}
.able {
    background: #5e89ef;
    color: #fff;
}
</style>
